// RPM-specific shared helpers / constants
export const VITAL_META = {
  bp_systolic:      { label: "Blood Pressure", short: "BP",     unit: "mmHg",  icon: "Activity" },
  bp_diastolic:     { label: "BP Diastolic",   short: "BP Dia", unit: "mmHg",  icon: "Activity" },
  heart_rate:       { label: "Heart Rate",     short: "HR",     unit: "bpm",   icon: "HeartPulse" },
  spo2:             { label: "SpO2",           short: "SpO2",   unit: "%",     icon: "Droplet" },
  temperature:      { label: "Temperature",    short: "Temp",   unit: "°C",    icon: "Thermometer" },
  respiratory_rate: { label: "Respiratory Rate", short: "RR",   unit: "rpm",   icon: "Wind" },
};

export const STATUS_COLORS = {
  normal:   { bg: "#ECFDF5", border: "#10B981", text: "#065F46", dot: "#10B981", chip: "#D1FAE5" },
  moderate: { bg: "#FFFBEB", border: "#F59E0B", text: "#92400E", dot: "#F59E0B", chip: "#FEF3C7" },
  critical: { bg: "#FEF2F2", border: "#EF4444", text: "#991B1B", dot: "#EF4444", chip: "#FEE2E2" },
  missing:  { bg: "#F8FAFC", border: "#94A3B8", text: "#475569", dot: "#94A3B8", chip: "#E2E8F0" },
};

export const RISK_COLORS = {
  stable:   { bg: "#ECFDF5", border: "#10B981", text: "#065F46", label: "Stable",   dot: "#10B981" },
  moderate: { bg: "#FFFBEB", border: "#F59E0B", text: "#92400E", label: "Moderate", dot: "#F59E0B" },
  high:     { bg: "#FFF7ED", border: "#F97316", text: "#9A3412", label: "High",     dot: "#F97316" },
  critical: { bg: "#FEF2F2", border: "#EF4444", text: "#991B1B", label: "Critical", dot: "#EF4444" },
  // News2 maps
  low: { bg: "#ECFDF5", border: "#10B981", text: "#065F46", label: "Low", dot: "#10B981" },
  medium: { bg: "#FFFBEB", border: "#F59E0B", text: "#92400E", label: "Medium", dot: "#F59E0B" },
};

export const INTERVENTION_TYPES = {
  patient_contacted: "Patient Contacted",
  caregiver_contacted: "Caregiver Contacted",
  repeat_reading_requested: "Repeat Reading Requested",
  teleconsultation_scheduled: "Teleconsultation Scheduled",
  physician_notified: "Physician Notified",
  medication_review_requested: "Medication Review Requested",
  ed_referral: "ED Referral",
  ambulance_recommended: "Ambulance Recommended",
  continue_monitoring: "Continue Monitoring",
};

export function timeAgo(iso) {
  if (!iso) return "—";
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60000) return "just now";
  const m = Math.floor(ms / 60000);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
